import { createSessionConsumer } from './actionCableConsumer';

interface NotificationChannelParams {
  connectedHandler?: () => void;
  disconnectedHandler?: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  receivedHandler?: (data: any) => void;
}

const notificationChannel = ({ connectedHandler, disconnectedHandler, receivedHandler }: NotificationChannelParams) => {
  const consumer = createSessionConsumer('notification');
  if (!consumer) return;

  return consumer.subscriptions.create(
    {
      channel: 'NotificationChannel'
    },
    {
      connected: connectedHandler,
      disconnected: disconnectedHandler,
      received: receivedHandler
    }
  );
};

export default notificationChannel;
